import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Http } from '@angular/http';

@Injectable()
export class EntityService extends ApiService {
  constructor(private http: Http) {
    super('api/entitys', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/entity.service.ts